const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const IST_OFFSET_MS = 330 * 60000;
const istFmt = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" });
const inNum = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export const todayIST = () => istFmt.format(new Date());
export const istDateOf = (iso) => (iso ? istFmt.format(new Date(iso)) : null);

export const fmtDate = (ymd) => {
  if (!ymd) return "—";
  const [y, m, d] = ymd.slice(0, 10).split("-");
  return `${d} ${MONTHS[Number(m) - 1]} ${y}`;
};

export const toISTInput = (iso) => (iso ? new Date(new Date(iso).getTime() + IST_OFFSET_MS).toISOString().slice(0, 16) : "");
export const fromISTInput = (v) => (v ? new Date(`${v}:00+05:30`).toISOString() : null);

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const local = toISTInput(iso);
  return `${fmtDate(local.slice(0, 10))}, ${local.slice(11, 16)}`;
};

export const fmtINR = (v) => {
  if (v === null || v === undefined || v === "" || Number.isNaN(Number(v))) return "—";
  const r = Math.round(Number(v));
  return `${r < 0 ? "−" : ""}₹${inNum.format(Math.abs(r))}`;
};

export const fmtPct = (v) => (v === null || v === undefined || v === "" ? "—" : `${Number(v)}%`);

export const fmtRate = (v) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(1)}%`);
export const fmtNum = (v, digits = 1) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: digits }));

export const daysBetween = (fromYmd, toYmd) => Math.round((Date.parse(toYmd) - Date.parse(fromYmd)) / 86400000);
